import React, { useState } from "react";
import { Card, Button, Modal } from "react-bootstrap";
import styles from "./sections.module.scss";

const InPatientSection = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingPatient, setEditingPatient] = useState(null);

  const [inPatientData, setInPatientData] = useState([
    {
      id: "IPD001",
      name: "Rahul Sharma",
      admissionDate: "2026-05-01T10:30:00",
      dischargeDate: null,
      ward: "General Ward",
      bedNo: "B12",
      doctor: "Dr. Mehta",
      status: "Admitted",
    },
    {
      id: "IPD002",
      name: "Anita Das",
      admissionDate: "2026-04-28T14:00:00",
      dischargeDate: "2026-05-02T11:00:00",
      ward: "Private Room",
      bedNo: "P03",
      doctor: "Dr. Rao",
      status: "Discharged",
    },
  ]);

  const [formData, setFormData] = useState({
    Service: "InPatient",
    IP_Service_Details: "Inpatient Advance Payment",
    Room_No: "",
    Bed_No: "",
    Allotted_Physician: "",
    Admission_Time: "",
    Discharge_Time: "",
    Admitted_Diagnosis: "",
    PayAmount: 0,
    Total_Advance_Pay: 0,
  });

  // ================= HANDLERS =================

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updated = { ...prev, [name]: value };

      if (name === "PayAmount") {
        updated.Total_Advance_Pay =
          Number(prev.Total_Advance_Pay || 0) + Number(value || 0);
      }

      return updated;
    });
  };

  const handleAdd = () => {
    setEditingPatient(null);
    setFormData({
      Service: "InPatient",
      IP_Service_Details: "Inpatient Advance Payment",
      Room_No: "",
      Bed_No: "",
      Allotted_Physician: "",
      Admission_Time: "",
      Discharge_Time: "",
      Admitted_Diagnosis: "",
      PayAmount: 0,
      Total_Advance_Pay: 0,
    });
    setShowAddModal(true);
  };

  const handleEdit = (item) => {
    setEditingPatient(item);
    setFormData({
      Service: "InPatient",
      IP_Service_Details: "Inpatient Advance Payment",
      Room_No: item.ward,
      Bed_No: item.bedNo,
      Allotted_Physician: item.doctor,
      Admission_Time: item.admissionDate,
      Discharge_Time: item.dischargeDate || "",
      Admitted_Diagnosis: "",
      PayAmount: 0,
      Total_Advance_Pay: 0,
    });
    setShowAddModal(true);
  };

  const handleSubmit = () => {
    if (editingPatient) {
      const updated = inPatientData.map((item) =>
        item.id === editingPatient.id
          ? {
              ...item,
              ward: formData.Room_No,
              bedNo: formData.Bed_No,
              doctor: formData.Allotted_Physician,
            }
          : item,
      );
      setInPatientData(updated);
    } else {
      const newPatient = {
        id: `IPD00${inPatientData.length + 1}`,
        name: "New Patient",
        admissionDate: formData.Admission_Time,
        dischargeDate: formData.Discharge_Time || null,
        ward: formData.Room_No,
        bedNo: formData.Bed_No,
        doctor: formData.Allotted_Physician,
        status: "Admitted",
      };
      setInPatientData((prev) => [...prev, newPatient]);
    }

    setShowAddModal(false);
  };

  const handleView = (patient) => {
    setSelectedPatient(patient);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedPatient(null);
  };

  // ================= UI =================

  return (
    <div className={styles.vitalReportWrapperCenter}>
      {/* HEADER */}
      <div className="d-flex justify-content-between mb-3">
        <h5>In Patient Records</h5>
        <Button size="sm" onClick={handleAdd}>
          + Add
        </Button>
      </div>

      {/* CARD VIEW */}
      {inPatientData.map((item) => (
        <Card key={item.id} className="mb-3 shadow-sm">
          <Card.Body className="d-flex justify-content-between align-items-center">
            <div>
              <h6>{item.name}</h6>
              <small>
                {item.ward} | Bed: {item.bedNo}
              </small>
            </div>

            <div className="d-flex gap-2">
              <span
                className={`badge ${
                  item.status === "Admitted" ? "bg-primary" : "bg-success"
                }`}
              >
                {item.status}
              </span>

              <Button size="sm" onClick={() => handleView(item)}>
                View
              </Button>

              <Button
                size="sm"
                variant="outline-secondary"
                onClick={() => handleEdit(item)}
              >
                Edit
              </Button>
            </div>
          </Card.Body>
        </Card>
      ))}

      {/* ================= TABLE LIKE VITAL ================= */}
      {inPatientData.length > 0 && (
        <div className={`mt-4 ${styles.invoiceWrapper}`}>
          <div className="table-responsive">
            <table className={styles.invoiceTable}>
              <thead>
                <tr>
                  <th className="text-start ps-4">Admission Date</th>
                  <th>Doctor</th>
                  <th>Ward</th>
                  <th>Bed</th>
                  <th>Status</th>
                  <th className="text-center pe-4">Action</th>
                </tr>
              </thead>

              <tbody>
                {inPatientData.map((item) => (
                  <tr key={item.id}>
                    <td className="text-start ps-4">
                      <div className="fw-bold text-dark">
                        {new Date(item.admissionDate).toLocaleDateString(
                          "en-GB",
                        )}
                      </div>
                      <small className="text-muted">
                        {new Date(item.admissionDate).toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                            hour12: true,
                          },
                        )}
                      </small>
                    </td>

                    <td>{item.doctor}</td>
                    <td>{item.ward}</td>
                    <td>{item.bedNo}</td>

                    <td>
                      <span
                        className={`${styles.statusBadge} ${
                          item.status === "Admitted"
                            ? styles.pending
                            : styles.paid
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>

                    <td className="text-center pe-4">
                      <div className="d-flex justify-content-center gap-2">
                        <Button
                          size="sm"
                          variant="outline-primary"
                          onClick={() => handleView(item)}
                        >
                          View
                        </Button>

                        <Button
                          size="sm"
                          variant="outline-secondary"
                          onClick={() => handleEdit(item)}
                        >
                          Edit
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {selectedPatient && (
        <Modal show={showModal} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>In Patient Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              <strong>Name:</strong> {selectedPatient.name}
            </p>
            <p>
              <strong>Doctor:</strong> {selectedPatient.doctor}
            </p>
            <p>
              <strong>Ward:</strong> {selectedPatient.ward}
            </p>
            <p>
              <strong>Bed:</strong> {selectedPatient.bedNo}
            </p>
            <p>
              <strong>Admission:</strong>{" "}
              {new Date(selectedPatient.admissionDate).toLocaleString()}
            </p>
            <p>
              <strong>Discharge:</strong>{" "}
              {selectedPatient.dischargeDate
                ? new Date(selectedPatient.dischargeDate).toLocaleString()
                : "Not yet"}
            </p>
          </Modal.Body>
        </Modal>
      )}

      {/* ADD / EDIT MODAL */}
      <Modal
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {editingPatient ? "Update In Patient" : "Add In Patient"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form className={styles.vitalFormGrid}>
            <div className={styles.formGroup}>
              <label>Service</label>
              <select className="form-select">
                <option>InPatient</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label>IP Service Details</label>
              <select className="form-select">
                <option>Inpatient Advance Payment</option>
              </select>
            </div>

            <div className={styles.formGroup}>
              <label>Room No</label>
              <input
                type="text"
                name="Room_No"
                value={formData.Room_No}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Bed No</label>
              <input
                type="text"
                name="Bed_No"
                value={formData.Bed_No}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Allotted Physician</label>
              <input
                type="text"
                name="Allotted_Physician"
                value={formData.Allotted_Physician}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Admitted Diagnosis</label>
              <input
                type="text"
                name="Admitted_Diagnosis"
                value={formData.Admitted_Diagnosis}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Admission Time</label>
              <input
                type="datetime-local"
                name="Admission_Time"
                value={formData.Admission_Time}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Discharge Time</label>
              <input
                type="datetime-local"
                name="Discharge_Time"
                value={formData.Discharge_Time}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Pay Amount</label>
              <input
                type="number"
                name="PayAmount"
                value={formData.PayAmount}
                onChange={handleFormChange}
                className="form-control"
              />
            </div>

            <div className={styles.formGroup}>
              <label>Total Advance Pay</label>
              <input
                type="number"
                value={formData.Total_Advance_Pay}
                readOnly
                className="form-control"
              />
            </div>
          </form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAddModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleSubmit}>
            Inpatient Pay
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InPatientSection;
